import ApiService from "../../../services/ApiService";
import Logger from "../../../services/Logger";

const GenImagePreviewService = {
    generatePuzzleImage: async (puzzleType, puzzleId) => {
        try {
            const response = await ApiService.putData(`/test/${puzzleType.toUpperCase()}/${puzzleId}/gen-puzzle-img`, {});
            return response;
        } catch (error) {
            Logger.error('Error generating puzzle image:', error);
            throw error;
        }
    },

    getPuzzle: async (puzzleType, puzzleId) => {
        try {
            // Determine the endpoint based on puzzle type
            const type = puzzleType === 'CROSSWORD' ? 'cross' : 'grid';
            const response = await ApiService.getData(`/home/${type}/${puzzleId}`);
            return response;
        } catch (error) {
            Logger.error('Error fetching puzzle:', error);
            throw error;
        }
    }
};

export default GenImagePreviewService;

